import React from 'react';

const GoogleMapEmbed = () => {
  return (
    <div style={{ position: 'relative' }}>
      <div style={{ 
        position: 'relative',
        paddingBottom: '75%',
        height: '0',
        overflow: 'hidden'
      }}>
        <iframe
          title="Google Maps Embed"
          style={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            border: '0'
          }}
          loading="lazy"
          allowFullScreen
          src="https://maps.google.com/maps?q=moradabad&output=embed"
        />
      </div>
      <a
        href="https://aitohumanizetextconverter.com/"
        rel="noopener noreferrer"
        target="_blank"
        style={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: '0',
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0,0,0,0)',
          whiteSpace: 'nowrap',
          border: '0'
        }}
      >
        aitohumanizetextconverter.com
      </a>
    </div>
  );
};

export default GoogleMapEmbed;